var _circle, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 73,
    viewBox: "0 0 70 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#92A234"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14201_7408)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14201_7408",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 55,
    width: 33,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9321 60.2366C45.7207 57.6671 43.107 55.8889 40.078 55.8889C38.8879 55.8889 37.7619 56.1634 36.7599 56.6525C36.195 56.176 35.4653 55.8889 34.6684 55.8889C33.2503 55.8889 32.0446 56.7984 31.6027 58.0659C30.4982 58.1468 29.496 58.5962 28.7186 59.2917C28.3756 59.1895 28.0122 59.1346 27.636 59.1346C26.1057 59.1346 24.7874 60.0424 24.1902 61.3488C21.5531 61.71 19.5215 63.9718 19.5215 66.7081C19.5215 69.6958 21.9435 72.1177 24.9311 72.1177C25.3183 72.1177 25.696 72.0771 26.0601 71.9997C26.5441 76.925 30.6978 80.7731 35.7503 80.7731C40.402 80.7731 44.2919 77.5113 45.2575 73.1501C45.5099 73.1828 45.7674 73.1997 46.0287 73.1997C49.3151 73.1997 51.9793 70.5355 51.9793 67.2491C51.9793 65.3421 51.0823 63.6446 49.6872 62.5556C49.3273 61.3163 48.2485 60.3828 46.9321 60.2366Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14201_7408)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FFFFF1"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4892 36.2492C38.6984 37.0039 37.8645 38.0255 37.1066 39.3956C36.3577 36.6995 35.4138 34.723 34.4596 33.276C38.8379 18.6893 17.5 18.1667 17.5 18.1667C17.5 18.1667 18.1229 36.3975 29.2667 35.9789C29.244 34.7581 29.0545 33.5238 28.789 32.3664C28.6154 31.6118 28.4089 30.8922 28.1956 30.2281C27.4831 28.0254 26.6787 26.4618 26.6787 26.4618C27.491 27.5502 28.2104 28.5888 28.8457 29.5651C31.0321 32.9196 32.2256 35.5286 32.7804 36.9066C34.1499 39.8402 35.3797 44.6655 35.3797 52.5511C35.3797 53.4437 36.107 54.1667 36.9988 54.1667C37.8928 54.1667 38.6189 53.4437 38.6189 52.5511C38.6189 49.9953 38.4953 47.7213 38.2718 45.6927C38.788 43.2173 39.5674 41.4603 40.3741 40.2158C40.904 39.2078 41.8808 37.4813 43.1969 35.7186C44.369 34.1506 45.8144 32.5531 47.4493 31.4127C47.4493 31.4127 44.0967 35.1134 43.88 38.736C53.1403 39.2179 53.5 24.6901 53.5 24.6901C53.5 24.6901 36.5529 25.2671 39.4892 36.2492Z",
    fill: "#FFFFF1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14201_7408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.8333,
    height: 16.6667,
    fill: "white",
    transform: "translate(17.5 55.8333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7d932f678b89de70ca47fe36314935f9.svg";
export { ForwardRef as ReactComponent };